.ux-table {
  display: block;
  position: relative;

  &--hide-on-mobile {
    display: none;
    @media only screen and (min-width: $tablet) {
      display: block;
    }
  }

  &--striped {
    tr:nth-child(even) td {
      background-color: $color-gray-background;
    }

    tr {
      td {
        border: 0;
      }
    }
  }

  ux-mobile-table {
    display: block;
    @media only screen and (min-width: $tablet) {
      display: none;
    }

    .ux-table-sort__icon {
      display: none;
    }
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
    margin: 0 auto;
    width: max-content;
  }

  &--same-column-width {
    table {
      width: unset;
    }
  }

  td,
  th {
    background-color: $color-white;
    border: 1px solid $color-gray-border;
    text-align: left;
    vertical-align: middle;
  }

  td {
    @include font(light);
    font-size: $size-text-medium;
    border-left: 0;
    padding: 13px 20px;
    text-transform: none;
  }

  &--no-wrap {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__icon-text {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  &__status-icon {
    font-size: 28px;
    margin-right: 8px;
  }

  th {
    @include font(bold);
    font-size: $size-text-small;
    text-transform: uppercase;
    background-color: $color-blue-5;
    padding: 25px;
  }

  // overriding PL styles
  /* stylelint-disable */
  thead tr {
    background-color: $color-blue-5;
  }

  thead th,
  thead td {
    border-top: 0;
    border-right: 1px solid $color-gray-border-dark;
    border-bottom: 1px solid $color-gray-border-dark;
  }

  tbody tr:nth-child(odd) td,
  tbody tr:nth-child(odd) th {
    background-color: $color-white;
  }

  td.first,
  tr td:first-child {
    font-size: inherit;
  }

  tr > td:first-child {
    @include font(light);
  }

  tbody tr:hover td {
    background-color: $color-blue-hover;
  }

  /* stylelint-enable */

  tr {
    background-color: $color-white;

    th:first-child,
    td:first-child {
      border-left: 0;
    }

    th:last-child,
    td:last-child {
      border-right: 0;
    }
  }

  &__inner {
    overflow-x: auto;
    height: auto;

    &::before,
    &::after {
      content: "";
      opacity: 0;
      position: absolute;
      z-index: 1;
      top: 50%;
      transform: translateY(-50%);
      width: 30px;
      height: calc(100% + 1px);
      pointer-events: none;
      transition: opacity 0.5s ease;
    }

    &::before {
      background: linear-gradient(to left, rgba(255, 255, 255, 0) 0, rgba(0, 0, 0, 0.1) 100%);
    }

    &::after {
      right: 0;
      background: linear-gradient(to right, rgba(255, 255, 255, 0.05) 0, #fff 100%);
    }
  }

  &--non-fixed-column &__inner::before {
    background: linear-gradient(to left, rgba(255, 255, 255, 0) 0, #fff 100%);
  }

  &__fixed-link {
    padding: 9px 2px 9px 8px;
    transform: translate(-50%, -50%);
    position: absolute;
    right: -3px;
    top: 50%;
    display: none;
  }

  &--has-left-shadow .ux-table__inner::before {
    opacity: 1;
  }

  &--has-right-shadow .ux-table__inner::after {
    opacity: 1;
  }

  &--full-width {
    table {
      min-width: 100%;
    }
  }

  &--is-fixed {
    table {
      min-width: auto;
    }

    .ux-table__fixed-link {
      display: inline-block;
    }

    td:nth-child(1) {
      z-index: 1;

      &:hover {
        z-index: 2;
      }
    }
  }

  &__copy-with-headline {
    @media only screen and (min-width: $tablet) {
      display: block;
    }
  }

  &--margin-right {
    margin-right: 50px;
  }
}
